import React from 'react';
import { Box, capitalize, Stack, Typography } from '@mui/material';
import SettingsSection from '../SettingsSection';
import useTerminalReader from '../../../hooks/businesses/useTerminalReader';
import { SettingsRow } from '../../../types/businesses';
import PurchaseTerminalSection from '../PurchaseTerminalSection';
import PageLoading from '../../global/PageLoading';

function TerminalSettings() {
  const { data: reader, isLoading } = useTerminalReader();

  const rows = React.useMemo<SettingsRow[]>(
    () =>
      reader
        ? [
            {
              id: 'status',
              title: 'Terminal Status',
              label: (
                <Stack direction="row" alignItems="center" gap={1} mt={0.5}>
                  <Typography variant="body2">
                    {reader?.status ? capitalize(reader.status) : 'N/A'}
                  </Typography>
                  {reader && (
                    <Box
                      bgcolor={theme =>
                        reader?.status === 'online'
                          ? theme.palette.success.main
                          : theme.palette.error.main
                      }
                      width={6}
                      height={6}
                      borderRadius="100%"
                    />
                  )}
                </Stack>
              ),
            },
            {
              id: 'serial',
              title: 'Serial Number',
              label: reader ? reader.serial_number : '-',
            },
          ]
        : [],
    [reader],
  );

  if (isLoading) return <PageLoading />;

  return reader ? (
    <SettingsSection isLoading={isLoading} rows={rows} />
  ) : (
    <PurchaseTerminalSection />
  );
}

export default TerminalSettings;
